import * as React from "react";
const SvgAffectedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M499.005 513H1.003L1.001 1.003q255.996 0 511.995-.002L513 512.997c-4.497.003-8.995.003-13.994.003" />
  </svg>
);
export default SvgAffectedIcon;
